export const VisitorAttachFileClassify = {
    List: [
        {label: "VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_SPECIAL_VEHICLE", value: "01"},
        {label: "VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_DRIVER_LICENSE", value: "02"},
        {label: "VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_LICENSE", value: "03"},
        {label: "VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_CONSTRUCTION_ORDER", value: "04"},
        {label: "VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_QUALIFICATION_CERTIFICATE", value: "05"},
        {label: "VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_ROAD_OPERATION_LICENSE", value: "06"},
        {label: "VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_SIDE_PHOTO", value: "07"},
    ],
    Map: new Map<string, string>([
        ['01', 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_SPECIAL_VEHICLE'],
        ['02', 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_DRIVER_LICENSE'],
        ['03', 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_LICENSE'],
        ['04', 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_CONSTRUCTION_ORDER'],
        ['05', 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_QUALIFICATION_CERTIFICATE'],
        ['06', 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_ROAD_OPERATION_LICENSE'],
        ['07', 'VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_SIDE_PHOTO'],
    ]),
    Enum: {
        SpecialVehicle: '01',
        DriverLicense: "02",
        VehicleLicense: '03',
        ConstructionOrder: '04',
        QualificationCertificate: '05',
        RoadOperationLicense: '06',
        VehicleSidePhoto: '07'
    }
};